import { MonitorPlay } from 'lucide-react';
import { createElement } from 'react';

import type { KhaiBaoModule } from '../../lib/modules.js';
import { TrangChiTietKenh } from './pages/TrangChiTietKenh.js';
import { TrangDanhSachKenh } from './pages/TrangDanhSachKenh.js';
import { TrangFormKenh } from './pages/TrangFormKenh.js';

const channels: KhaiBaoModule = {
  id: 'channels',
  nav: {
    group: 'VẬN HÀNH',
    label: 'Kênh',
    badge: 'so-kenh',
    icon: MonitorPlay,
    order: 2,
    permission: 'channels',
    to: '/kenh',
  },
  routes: [
    {
      path: '/kenh',
      element: createElement(TrangDanhSachKenh),
      permission: { module: 'channels', level: 'view' },
    },
    {
      path: '/kenh/moi',
      element: createElement(TrangFormKenh),
      permission: { module: 'channels', level: 'edit' },
    },
    {
      path: '/kenh/:id',
      element: createElement(TrangChiTietKenh),
      permission: { module: 'channels', level: 'view' },
    },
    {
      path: '/kenh/:id/sua',
      element: createElement(TrangFormKenh),
      permission: { module: 'channels', level: 'edit' },
    },
  ],
};

export default channels;
